module.exports = __webpack_public_path__ + "img/ring_r_c_null_0.14674c9c.png";